module.exports = __webpack_public_path__ + "static/img/4.de7709b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/15/zh/4.png
// module id = nURx
// module chunks = 0